export default "__VITE_ASSET__D1zo6A6$__"